// extracted by mini-css-extract-plugin
export default {"wrapper":"Canvas_wrapper__XBNMR","cell":"Canvas_cell__iaYbZ","selected":"Canvas_selected__bvm-X","preview":"Canvas_preview__YDcw9","container":"Canvas_container__ZFekU"};